    import React, { useState, useEffect } from "react";
    import { Button, Grid, FormControl, MenuItem, Card, IconButton, Select, } from "@mui/material";
    import { ArrowDropDown } from "@mui/icons-material";
    import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
    import DashboardNavbar from "examples/Navbars/DashboardNavbar";
    import Footer from "examples/Footer";
    import MDBox from "ui/MDBox";
    import MDTypography from "ui/MDTypography";
    import MDInput from "ui/MDInput";
    import MDAlert from "ui/MDAlert";
    import meetingServices from "services/meeting-services";
    import centerService from "services/center-service";
    import { SaveButton } from "layouts/common/buttons";
    import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
    import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
    import { DatePicker } from "@mui/x-date-pickers/DatePicker";
    import dayjs from "dayjs";


    const AddMeeting = () => {
        const [loading, setLoading] = useState(false);
        const [notification, setNotification] = useState(false);
        const [centers, setCenters] = useState([]);

        const [meetingData, setMeetingData] = useState({
            title: "",
            date: "",
            center: "",
            level: "",
            venue: "",
        });

        const [errors, setErrors] = useState({
            titleError: false,
            dateError: false,
            centerError: false,
            levelError: false,
        });

        // 🔔 Auto hide notification after 5s
        useEffect(() => {
            if (notification) {
                const timer = setTimeout(() => setNotification(false), 5000);
                return () => clearTimeout(timer);
            }
        }, [notification]);

        // 🏢 Fetch centers on mount
        useEffect(() => {
            const fetchCenters = async () => {
                try {
                    const res = await centerService.getAll();
                    if (res?.success && res.centers) setCenters(res.centers);
                } catch (err) {
                    console.error("Error fetching centers:", err);
                }
            };
            fetchCenters();
        }, []);

        // 📝 Change handler for all inputs
        const changeHandler = (e) => {
            const { name, value } = e.target;
            setMeetingData((prev) => ({ ...prev, [name]: value }));
        };

        // 🏢 Handle center change + auto venue
        const handleCenterChange = (e) => {
            const selectedCenterId = e.target.value;
            const selectedCenter = centers.find((c) => c.id === selectedCenterId);
            setMeetingData((prev) => ({
                ...prev,
                center: selectedCenterId,
                venue: selectedCenter ? selectedCenter.name : "",
            }));
        };

        // 🚀 Submit form
        const submitHandler = async (e) => {
            e.preventDefault();

            // Reset errors
            setErrors({
                titleError: false,
                dateError: false,
                centerError: false,
                levelError: false,
            });

            // Validation
            if (!meetingData.title.trim())
                return setErrors((prev) => ({ ...prev, titleError: true }));

            if (!meetingData.date.trim())
                return setErrors((prev) => ({ ...prev, dateError: true }));

            if (!meetingData.center.trim())
                return setErrors((prev) => ({ ...prev, centerError: true }));

            if (!meetingData.level.trim())
                return setErrors((prev) => ({ ...prev, levelError: true }));

            const newMeetingData = {
                title: meetingData.title,
                date: meetingData.date,
                center: meetingData.center,
                level: meetingData.level,
                venue: meetingData.venue,
            };

            console.log("Sending meeting data:", newMeetingData);
            setLoading(true);

            const response = await meetingServices.create(newMeetingData);
            setLoading(false);

            if (response?.success) {
                setNotification({ type: "success", message: response.message });
                setMeetingData({
                    title: "",
                    date: "",
                    center: "",
                    level: "",
                    venue: "",
                });
            } else {
                setNotification({ type: "error", message: response.message });
            }
        };

        return (
            <DashboardLayout>
                <DashboardNavbar />
                <MDBox pt={6} pb={3}>
                    <Grid container spacing={6}>
                        <Grid item xs={12}>
                            <Card>
                                <MDBox
                                    mx={2}
                                    mt={-3}
                                    py={3}
                                    px={2}
                                    variant="gradient"
                                    bgColor="info"
                                    borderRadius="lg"
                                    coloredShadow="info"
                                    display="flex"
                                    justifyContent="space-between"
                                    alignItems="center"
                                >
                                    <MDTypography variant="h6" color="white">
                                        Meeting
                                    </MDTypography>
                                    <SaveButton loading={loading} onClick={submitHandler} />
                                </MDBox>

                                <MDBox
                                    component="form"
                                    onSubmit={submitHandler}
                                    display="flex"
                                    flexDirection="column"
                                    py={0}
                                    px={3}
                                >
                                    {notification && (
                                        <MDAlert color={notification.type} mt="20px">
                                            <MDTypography variant="body2" color="white">
                                                {notification.message}
                                            </MDTypography>
                                        </MDAlert>
                                    )}

                                    <MDBox display="flex" flexDirection="row" mt={5} mb={3}>
                                        <MDBox display="flex" flexDirection="column" alignItems="flex-start" width="100%" mr={2}>
                                            <MDTypography variant="body2" ml={1}>
                                                Title
                                            </MDTypography>
                                            <MDBox mb={2} width="100%">
                                                <MDInput
                                                    name="title"
                                                    type="text"
                                                    fullWidth
                                                    placeholder="Title"
                                                    value={meetingData.title}
                                                    onChange={changeHandler}
                                                    error={errors.titleError}
                                                />
                                                {errors.titleError && (
                                                    <MDTypography variant="caption" color="error">
                                                        Please Provide Title
                                                    </MDTypography>
                                                )}
                                            </MDBox>
                                        </MDBox>


                                        <MDBox display="flex" flexDirection="column" alignItems="flex-start" width="100%" mr={2}>
                                            <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                                                Date
                                            </MDTypography>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    inputFormat="YYYY-MM-DD"
                                                    value={meetingData.date ? dayjs(meetingData.date) : null}
                                                    minDate={dayjs().subtract(1, "day")} // 👈 Allow only one day before today
                                                    onChange={(newValue) => {
                                                        if (newValue && newValue.isBefore(dayjs().subtract(1, "day"), "day")) {
                                                            setNotification({
                                                                type: "error",
                                                                message: "You cannot select a date earlier than one day before today!",
                                                            });
                                                            return;
                                                        }
                                                        setMeetingData((prev) => ({
                                                            ...prev,
                                                            date: newValue ? newValue.format("YYYY-MM-DD") : "",
                                                        }));
                                                    }}
                                                    renderInput={(params) => (
                                                        <MDBox mb={2} width="100%">
                                                            <MDInput
                                                                {...params}
                                                                fullWidth
                                                                error={errors.dateError}
                                                                helperText={errors.dateError ? "Please provide date" : ""}
                                                            />
                                                        </MDBox>
                                                    )}
                                                />
                                            </LocalizationProvider>

                                        </MDBox>



                                        <MDBox display="flex" flexDirection="column" alignItems="flex-start" width="100%" mr={2}>
                                            <MDTypography variant="body2" ml={1}>
                                                Center/Venue
                                            </MDTypography>
                                            <MDBox mb={1} width="100%">
                                                <FormControl fullWidth>
                                                    <Select
                                                        value={meetingData.center || "default"}
                                                        onChange={handleCenterChange}
                                                        error={errors.centerError}
                                                        IconComponent={() => (
                                                            <IconButton>
                                                                <ArrowDropDown />
                                                            </IconButton>
                                                        )}
                                                    >
                                                        <MenuItem disabled value="default">
                                                            Select Center
                                                        </MenuItem>
                                                        {centers.map((center) => (
                                                            <MenuItem key={center.id} value={center.id}>
                                                                {center.name}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                    {errors.centerError && (
                                                        <MDTypography variant="caption" color="error">
                                                            Please Provide Center/Venue
                                                        </MDTypography>
                                                    )}
                                                </FormControl>
                                            </MDBox>
                                        </MDBox>
                                    </MDBox>
                                    <MDBox display="flex" flexDirection="row" mb={3}>
                                        <MDBox display="flex" flexDirection="column" alignItems="flex-start" width="32%" mr={2}>
                                            <MDTypography variant="body2" ml={1}>
                                                Meeting Level
                                            </MDTypography>
                                            <MDBox mb={2} width="100%">
                                                <FormControl fullWidth>
                                                    <Select
                                                        name="level"
                                                        value={meetingData.level || "default"}
                                                        onChange={changeHandler}
                                                        error={errors.levelError}
                                                        IconComponent={() => (
                                                            <IconButton>
                                                                <ArrowDropDown />
                                                            </IconButton>
                                                        )}
                                                    >
                                                        <MenuItem disabled value="default">
                                                            Select Level
                                                        </MenuItem>
                                                        <MenuItem value="center">Center Level</MenuItem>
                                                        <MenuItem value="city">City Level</MenuItem>
                                                    </Select>
                                                    {errors.levelError && (
                                                        <MDTypography variant="caption" color="error">
                                                            Please Provide Level
                                                        </MDTypography>
                                                    )}
                                                </FormControl>
                                            </MDBox>
                                        </MDBox>
                                    </MDBox>
                                </MDBox>
                            </Card>
                        </Grid>
                    </Grid>
                </MDBox>
                <Footer />
            </DashboardLayout>
        );
    };

    export default AddMeeting;
